var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[(_vm.breadcrumbs)?_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs}}):_vm._e(),_c('transition',{attrs:{"name":_vm.transition,"mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }